import { ColumnDef, ColumnHelper } from '@tanstack/react-table'

import { commonAccessorColumn, dateAccessorColumn, moneyAccessorColumn } from '@/components/table'
import { OperationType, RefundSbpButton, SbpPaymentStatus } from '@/components'
import { Nullable, SbpPayment } from '@/types.ts'
import { EMPTY_VALUE } from '@/constants.ts'

export const KEY_PAGE = 'sbp'

type VisibleColumns =
  | 'operationId'
  | 'reference'
  | 'requestId'
  | 'createTime'
  | 'type'
  | 'reversedOperationId'
  | 'state'
  | 'amount'
  | 'commissionMerchant'
  | 'toMerchant'

export type PartialSbpPayment = Pick<SbpPayment, VisibleColumns>

export const defaultSettings: Record<keyof PartialSbpPayment, string> = {
  operationId: '№ операции',
  reference: '№ заказа торговой точки',
  requestId: '№ заявки на QR-код',
  createTime: 'Дата создания',
  // payMethod: 'Платежный метод',
  type: 'Тип операции',
  reversedOperationId: 'Возврат № операции',
  state: 'Статус операции',
  amount: 'Сумма операции',
  commissionMerchant: 'Комиссия по договору',
  toMerchant: 'Сумма зачисления на счет',
}

export function getColumnsSettings(
  columnHelper: ColumnHelper<SbpPayment>
): Record<keyof PartialSbpPayment, ColumnDef<SbpPayment, any>> {
  return {
    operationId: columnHelper.accessor('operationId', commonAccessorColumn('№ операции')),
    reference: columnHelper.accessor('reference', commonAccessorColumn('№ заказа торговой точки')),
    requestId: columnHelper.accessor('requestId', commonAccessorColumn('№ заявки на QR-код')),
    createTime: columnHelper.accessor('createTime', dateAccessorColumn('Дата создания', true, 'Europe/Moscow')),
    // payMethod: columnHelper.accessor((row) => row.type, {
    //   id: 'payMethod',
    //   header: 'Платежный метод',
    //   cell: (props) => <OperationType value={props.getValue()} paymentTypeLabels />,
    // }),
    type: columnHelper.accessor('type', {
      header: 'Тип операции',
      cell: (props) => <OperationType value={props.getValue()} />,
    }),
    reversedOperationId: columnHelper.accessor(
      'reversedOperationId',
      commonAccessorColumn(() => (
        <>
          Возврат
          <br />№ операции
        </>
      ))
    ),
    state: columnHelper.accessor('state', {
      header: 'Статус операции',
      cell: (props) => <SbpPaymentStatus state={props.getValue()} type={props.row.original.type} />,
      enableSorting: true,
    }),
    amount: columnHelper.accessor('amount', moneyAccessorColumn('Сумма операции')),
    commissionMerchant: columnHelper.accessor('commissionMerchant', moneyAccessorColumn('Комиссия по договору')),
    toMerchant: columnHelper.accessor('toMerchant', {
      header: 'Сумма зачисления на счет',
      cell: (props) =>
        props.getValue()
          ? `${props.row.original.type === 'REVERSE' ? '-' : ''}${(
              (props.getValue() as Nullable<number | string>) ?? 0
            )?.toLocaleString('ru-RU', {
              style: 'currency',
              currency: props.row.original.cur ?? 'RUB',
            })}`
          : EMPTY_VALUE,
    }),
  }
}

export const getStaticColumns = (
  columnHelper: ColumnHelper<SbpPayment>
): Record<string, ColumnDef<SbpPayment, any>> => {
  return {
    'refund-action': columnHelper.display({
      id: 'refund-action',
      enableSorting: false,
      cell: (props) => <RefundSbpButton {...props.row.original} />,
    }),
  }
}
